import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';

const ThinkingDots: FC = () => {
  const { t } = useTranslate();

  return (
    <div
      className="navi-thinking-dots"
      aria-label={t('CHATBOT_ThinkingAriaLabel')}
    >
      <span />
      <span />
      <span />
    </div>
  );
};

export default ThinkingDots;
